import { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { IconShieldCheck, IconKey, IconBrandWhatsapp } from "@tabler/icons-react";
import TurnstileWidget from "../../../components/TurnstileWidget";

const TokenValidation = ({ 
  token, 
  onValidationSuccess, 
  isLoading, 
  error, 
  turnstileResetTrigger 
}) => {
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileError, setTurnstileError] = useState("");

  // Handlers do Turnstile
  const handleTurnstileSuccess = (token) => {
    setTurnstileToken(token);
    setTurnstileError("");
  };

  const handleTurnstileError = (errorMessage) => {
    setTurnstileError(errorMessage || "Erro na validação de segurança. Tente novamente.");
    setTurnstileToken(null);
  };

  const handleTurnstileExpired = () => {
    setTurnstileToken(null);
    setTurnstileError("Validação de segurança expirou. Complete novamente.");
  };

  // Handler do formulário
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!turnstileToken) {
      setTurnstileError("Complete a validação de segurança primeiro.");
      return;
    }

    onValidationSuccess({ token }, turnstileToken);
  };


  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={6} md={8} sm={10}>
          <Card className="border-0 shadow-lg">
            <Card.Body className="p-5">
              {/* Header */}
              <div className="text-center mb-5">
                <div
                  className="mx-auto mb-4 rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "80px",
                    height: "80px",
                    background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                    color: "white",
                    boxShadow: "0 8px 32px rgba(37, 211, 102, 0.3)"
                  }}
                >
                  <IconBrandWhatsapp size={40} />
                </div>
                
                <h2 className="fw-bold text-dark mb-2">
                  Conectar ao WhatsApp
                </h2>
                <p className="text-muted mb-0">
                  Digite seu token de 6 dígitos para continuar
                </p>
              </div>

              {/* Informações do Token */}
              <div className="mb-4">
                <div className="d-flex align-items-center gap-3 p-3 rounded-3" 
                     style={{ background: "#f8f9fa", border: "1px solid #e9ecef" }}>
                  <div className="d-flex align-items-center justify-content-center rounded-circle"
                       style={{ width: "40px", height: "40px", background: "#e3f2fd" }}>
                    <IconKey size={20} style={{ color: "#1976d2" }} />
                  </div>
                  <div>
                    <small className="fw-medium text-dark">Token fornecido:</small>
                    <div className="fw-bold" style={{ color: "#1976d2", letterSpacing: "2px" }}>
                      {token}
                    </div>
                  </div>
                </div>
              </div>

              {/* Formulário */}
              <Form onSubmit={handleSubmit}>

                {/* Turnstile */}
                <div className="mb-4">
                  <div className="d-flex flex-column align-items-center">
                    <TurnstileWidget
                      onTokenChange={handleTurnstileSuccess}
                      onError={handleTurnstileError}
                      onExpired={handleTurnstileExpired}
                      resetTrigger={turnstileResetTrigger}
                      theme="light"
                      size="normal"
                      className="w-100"
                    />
                    {turnstileError && (
                      <Alert variant="warning" className="mt-3 mb-0 w-100">
                        <small>{turnstileError}</small>
                      </Alert>
                    )}
                  </div>
                </div>

                {/* Erro Geral */}
                {error && (
                  <Alert variant="danger" className="mb-4">
                    {error}
                  </Alert>
                )}

                {/* Botão de Envio */}
                <div className="d-grid">
                  <Button
                    type="submit"
                    size="lg"
                    disabled={
                      isLoading || 
                      !turnstileToken
                    }
                    style={{
                      background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
                      border: "none",
                      borderRadius: "12px",
                      fontWeight: "600",
                      padding: "16px",
                      boxShadow: turnstileToken 
                        ? "0 8px 32px rgba(37, 211, 102, 0.3)" 
                        : "none"
                    }}
                  >
                    {isLoading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Validando...
                      </>
                    ) : (
                      <>
                        <IconShieldCheck size={20} className="me-2" />
                        Validar e Continuar
                      </>
                    )}
                  </Button>
                </div>
              </Form>

              {/* Informações de Segurança */}
              <div className="mt-5 pt-4" style={{ borderTop: "1px solid #e9ecef" }}>
                <div className="text-center">
                  <small className="text-muted">
                    🔒 Sua conexão está protegida por validação de segurança avançada
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TokenValidation;